import React, {useState} from "react";
import { useNavigate } from "react-router-dom";
import SkeletonLoader from "../skeletonLoader";

const ImageWithText = ({ goToPage, slides }) => {
  const navigate = useNavigate();
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleClick = () => {
    console.log("Slide", slides);

    navigate(slides?.imageInfo?.onClick); // Navigate within the app
  };

  const imageUrl = slides?.imageInfo?.url;
  const altText = slides?.imageInfo?.altText || "Image";


     return (
    <div
      onClick={handleClick}
      className="relative w-full h-[200px] custom-md:h-[400px] cursor-pointer overflow-hidden"
    >
      {/* Skeleton loader with fixed size */}
      {(!imageLoaded || !slides) && (
        
        <SkeletonLoader/>


      )}

      {/* Image (fade in after load) */}
      {slides && (
        <img
          src={imageUrl}
          alt={altText}
          onLoad={() => setImageLoaded(true)}
          className={`w-full h-full object-cover transition-opacity duration-500 ${
            imageLoaded ? "opacity-100" : "opacity-0"
          }`}
        />
      )}

      {/* Overlay Text */}
      {imageLoaded && slides && (
        <div className="absolute inset-0 bg-transparent z-20">
          <div className="absolute bottom-0 left-0 p-4 custom-md:p-6 text-white">
            <h2 className="text-lg custom-md:text-2xl font-bold mb-1 custom-md:mb-2">
              {slides.title}
            </h2>
            <p className="text-xs custom-md:text-sm">{slides.description}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageWithText;